import { REGION_LIST } from '@ms/setting'

const getRegion = () => {
  const isLocal = location.hostname === 'localhost' || location.hostname === '127.0.0.1'
  if (isLocal && window.COUNTRY) {
    return window.COUNTRY
  }

  if (!isLocal) {
    const matched = location.pathname.match(/^\/([a-z]+)/)
    if (matched && matched[1]) {
      return matched[1]
    }
  }
  const cachedRegion = localStorage.getItem('USER_REGION')
  const isValid = cachedRegion && REGION_LIST.some((item) => cachedRegion === item.country)
  if (isValid) {
    return cachedRegion
  } else {
    localStorage.removeItem('USER_REGION')
    return process.env.COUNTRY
  }
}
/* 当前国家 app region */
export const REGION = getRegion()

const getAppLinks = () => {
  return {
    appAndroidApk: location.origin + `/api/${REGION}/common/config/latestDownload/android`,
    appIosAppleStore: `https://apps.apple.com/${REGION}/app/msport-sports-betting-casino/id1606727725`
  }
}

export const appLinks = getAppLinks()

export const prefixLink = (link = '') => (/^http/.test(link) ? link : `/${REGION}${link}`)
export const prefixLinkOfWeb = (link = '') => `/${REGION}/web${link}`

export const URL_TERMS_CONDITIONS = prefixLink('/support/about/terms-and-conditions')
export const URL_TERMS_CONDITIONS_WEB = prefixLinkOfWeb('/support/about/terms-and-conditions')
